import {writeChunk} from "_src/engine/loaders/utils"

export default {

  encodeMain(geometry) {
    return writeChunk(geometry);
  },

  cleanup() {
    return Promise.resolve();
  }

}
